"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));

var _getSpacingToken = _interopRequireDefault(require("../common/getSpacingToken"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var StyledSeparator = _styledComponents.default.hr.withConfig({
  displayName: "Separator__StyledSeparator",
  componentId: "sc-8j6gay-0"
})(["width:100%;height:", ";background:", ";box-sizing:border-box;border-style:none;margin-top:0;margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.heightSeparator;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.backgroundSeparator;
}, _getSpacingToken.default);

StyledSeparator.defaultProps = {
  theme: _defaultTheme.default
};

var Separator = function Separator(_ref3) {
  var spaceAfter = _ref3.spaceAfter;
  return React.createElement(StyledSeparator, {
    spaceAfter: spaceAfter
  });
};

var _default = Separator;
exports.default = _default;